// extracted by mini-css-extract-plugin
export default {"slider":"slider__slider___2yE0Z"};